// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._152tze3t{inset-block-start:var(--ds-space-0,0)}
._18m91wug{overflow-y:auto}
._1bsbauwl{width:100vw}
._1e02ze3t{inset-inline-start:var(--ds-space-0,0)}
._4t3i1kxc{height:100vh}
._8am5i4x0{-webkit-overflow-scrolling:touch}
._kqsw1n9t{position:fixed}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/node_modules/@atlaskit/modal-dialog/dist/esm/modal-wrapper.compiled.css"],"names":[],"mappings":"AAAA,WAAW,qCAAqC;AAChD,WAAW,eAAe;AAC1B,WAAW,WAAW;AACtB,WAAW,sCAAsC;AACjD,WAAW,YAAY;AACvB,WAAW,gCAAgC;AAC3C,WAAW,cAAc","sourcesContent":["._152tze3t{inset-block-start:var(--ds-space-0,0)}\n._18m91wug{overflow-y:auto}\n._1bsbauwl{width:100vw}\n._1e02ze3t{inset-inline-start:var(--ds-space-0,0)}\n._4t3i1kxc{height:100vh}\n._8am5i4x0{-webkit-overflow-scrolling:touch}\n._kqsw1n9t{position:fixed}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
